import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import LoadTable from "../LoadTable/LoadTable";
import Loading from "../Loading/Loading";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import "./SelectDataFromTable.scss"
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ConvertDateValues } from "../../custom_hooks/ChangeDateValues";

export const SelectDataFromTable = ({ toggle, setToggle, query, dataKey, variables, setselectedData, selectedData, setFirstLoad }) => {
  console.log(query, variables)
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const SelectedData = fielddataRedux?.Select_Data?.Selected_Rows;
  const { data, error, loading } = useQuery(query, { variables, fetchPolicy: "network-only" })
  const [Data, setData] = useState([])
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) {
      let dataArr = [...data[dataKey]]
      // const idsInData = new Set(dataArr.map(item => item._id));

      // selectedData?.forEach(item => {
      //   if (!idsInData.has(item._id)) {
      //     // Create a compatible structure if needed


      //     dataArr.unshift(item); // add at beginning
      //   }
      // });
      setData(dataArr)
    }
    else {
      setData([])
    }
  }, [data])

  const closeFun = () => {
    setFirstLoad(true)
    setselectedData(SelectedData)
    const payloadData = { key: "Select_Data", data: [] };
    dispatch({ type: "UNIQUE_TABLE_LIST", payload: payloadData });
    setToggle(false);
  }
  // console.log(Data, selectedData)
  return <>
    <Reactportal
      open={toggle}
      onClose={() => setToggle(false)}
      TypeOfPortal={""}
    >
      <div className="DataContainer1">
        {
          loading ? <Loading /> : Data && Data.length > 0 ? <LoadTable title={`Select_Data`} data={ConvertDateValues(Data)} error={error} selectedRows={selectedData} /> :
            <p className="DataNotAvailable">Data not Available</p>
        }
      </div>
      <div>
        <PortalFooter
          renderContent={() => (<></>)}
          submitform={() => { }}
          submitType={""}

          handleformclose={() => {
            closeFun()

          }}
          Cancletype={"Select"}
        />
      </div>
    </Reactportal>
  </>
}